import { computed } from 'vue'
/**
 *
 * @param {Object} object
 * @param {boolean} toObject
 * @returns {Object|string} modernizr style
 */
export const useModernizrStyleClasses = (object, toObject = false) => {
  return computed(() => {
    const returnValue = {}
    Object.keys(object).forEach(key => {
      if (object[key].value === true) {
        returnValue[key] = true
      } else {
        returnValue[`no-${key}`] = true
      }
    })
    if (!toObject) {
      return Object.keys(returnValue).join(' ')
    }
    return returnValue
  })
}
export default useModernizrStyleClasses
